
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type SearchBoxDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function SearchBoxDialogRT(): TemplateResult<SearchBoxDialogRTRootProps> {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog' }, _createElement('div', { 'className': 'clear-self cm_search-box_container' }, _createElement('div', { 'className': 'dialog-container' }, _createElement('div', {
        'className': 'search-bar dialog-content',
        'onSubmit': this.preventFormSubmission
    }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', { 'className': 'dialog-title' }, _translate(`search_box_dialog_title`)), _createElement('div', {
        'className': 'cm_search-box-dialog_close-button close',
        'onClick': this.close
    }, _createElement('svg', {
        'className': 'cm_icon cm_icon-times',
        'height': '20px',
        'role': 'img',
        'viewBox': '0 0 22 22'
    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' })))), _createElement('div', { 'className': 'cm_search-box_form-container search-bar__top' }, [
        [this.searchInput(function () {
                return _createElement('div', { 'className': 'search-bar__input cm_searchInput' }, window.Convermax.config?.searchBoxPlaceholderText || _translate(`search_box_placeholder`));
            }, {
                widgetName: 'undefined',
                items: undefined
            })],
        _createElement('span', {
            'className': 'cm_search-box_clear-container',
            'key': '6402'
        }, this.inputNotEmpty ? _createElement('span', {
            'className': 'cm_search-box_clear',
            'onClick': this.clearInput,
            'key': '1014'
        }, '\n    ', _translate(`search_box_clear`), '\n  ') : null),
        _createElement('button', {
            'type': 'button',
            'title': 'Search',
            'aria-label': 'search button',
            'className': 'cm_search-box_submit search-bar__submit',
            'data-cm-role': 'add-query',
            'key': '6404'
        }, [_createElement('svg', {
                'focusable': 'false',
                'className': 'icon icon--search',
                'viewBox': '0 0 21 21',
                'role': 'presentation',
                'key': '13000'
            }, _createElement('g', {
                'strokeWidth': '2',
                'stroke': 'currentColor',
                'fill': 'none',
                'fillRule': 'evenodd'
            }, _createElement('path', {
                'd': 'M19 19l-5-5',
                'strokeLinecap': 'square'
            }), _createElement('circle', {
                'cx': '8.5',
                'cy': '8.5',
                'r': '7.5'
            })))])
    ]), [this.dropdown(function () {
            function repeatSections1(sections, sectionsIndex) {
                return [sections(function () {
                        function repeatItems1(items, itemsIndex) {
                            return [items(function () {
                                    function mergeProps_text(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function mergeProps_product(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    function repeatI2_product(i, iIndex) {
                                        return _createElement('span', {
                                            'key': i,
                                            'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                                        });
                                    }
                                    function onError1_facetValue(e) {
                                        e.target.classList.add('cm_hide');
                                    }
                                    function mergeProps_facetValue(inline, external) {
                                        var res = Object.assign({}, inline, external);
                                        if (inline.hasOwnProperty('style')) {
                                            res.style = _.defaults(res.style, inline.style);
                                        }
                                        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                                            res.className = external.className + ' ' + inline.className;
                                        }
                                        return res;
                                    }
                                    return this.template === 'text' ? _createElement('div', mergeProps_text({ 'className': 'cmTemplate_text' }, { dangerouslySetInnerHTML: { __html: typeof this.textHighlight === 'undefined' ? '' : this.textHighlight } })) : this.template === 'product' ? _createElement('div', { 'className': 'cmTemplate_product' }, _createElement('div', { 'className': 'image-block' }, _createElement('img', {
                                        'src': this.imageOrDefault(this.resizeImage(this.image || this.image1)),
                                        'alt': 'Image of ' + this.removeHTML(this.title),
                                        'onError': this.onImageError
                                    })), _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_product({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'price' }, '\n    ', this.price_varies ? `${ _translate(`price_from`) } ` : '', this.formatPrice(this.min_price || this.price), '\n  '), [this.review_count ? _createElement.apply(this, [
                                            'div',
                                            {
                                                'className': 'cm_review-stars',
                                                'key': '5620'
                                            },
                                            _map([
                                                0,
                                                1,
                                                2,
                                                3,
                                                4
                                            ], repeatI2_product.bind(this)),
                                            _createElement('span', { 'className': 'cm_review-count' }, this.review_count, ' ', _translate(`product_reviews_title`))
                                        ]) : null])) : this.template === 'facetValue' ? _createElement('div', { 'className': 'cmTemplate_facetValue' }, this.imageUrl ? _createElement('div', {
                                        'className': 'image-block',
                                        'key': '35'
                                    }, _createElement('img', {
                                        'src': this.imageUrl,
                                        'alt': 'Image of ' + this.facetValue,
                                        'onError': onError1_facetValue.bind(this)
                                    })) : null, _createElement('div', { 'className': 'description-block' }, _createElement('div', mergeProps_facetValue({ 'className': 'title' }, { dangerouslySetInnerHTML: { __html: typeof this.value === 'undefined' ? '' : this.value } })), this.hitCount ? _createElement('span', {
                                        'className': 'hit-count',
                                        'key': '400'
                                    }, '(', this.hitCount, ')') : null)) : _createElement('div', { 'className': 'cmTemplate_Unknown' }, JSON.stringify(this));
                                }, { count: undefined })];
                        }
                        return _createElement('div', { 'className': 'section' + (this.sectionTitle ? ` ${ this.sectionTitle }` : '') }, _createElement('div', { 'className': 'section-title-div' }, _createElement('div', { 'className': 'item section-title' }, _createElement('b', {}, '\n          ', this.totalHits && _translate(`search_box_products_count`, {  totalHits : this. totalHits  }), ' ', _translate(`search_box_section_${ this.sectionTitle }`) || this.sectionTitle, '\n        '), '\n        ', this.vehicleString && _translate(`search_box_dropdown_vehicle`, {  vehicleString : this. vehicleString  }), '\n      ')), _createElement.apply(this, [
                            'div',
                            { 'className': 'cmRepeater_items' },
                            _map(this.items, repeatItems1.bind(this))
                        ]));
                    }, { count: undefined })];
            }
            return _createElement('div', { 'className': 'dialog-body cm_autocomplete cm_dropdown' }, _createElement.apply(this, [
                'div',
                { 'className': 'cmRepeater_sections' },
                _map(this.sections, repeatSections1.bind(this))
            ]), this.browseAllButton ? [[this.browseAllButton(function () {
                        return _createElement('a', { 'className': 'item button-item cm_browseAllButton' }, _translate(`search_box_dropdown_browse`, { 
                            totalHits: this.
                            totalHits, 
                            query
                        : this.
                            query
                         }));
                    }, {
                        widgetName: 'undefined',
                        items: undefined
                    })]] : null, this.noResults ? _createElement('div', {
                'className': 'item cm_search-box_no-results',
                'key': '6142'
            }, '\n  ', _translate(`search_box_no_results`, {  query : this. query  }), '\n') : null);
        }, {
            widgetName: 'undefined',
            items: undefined
        })]))));
}
        export const componentNames = ["cm:searchInput","cm:browseAllButton","cm:dropdown"]